<template>
  <VView class="contest-game" back-button-to="/menu" header="Poziom 2">
    <div class="contest-game__wrapper">
      <VGame @end="onGameEnd($event)" />
    </div>
  </VView>
</template>

<script>
import VText from '@/components/VText.vue';
import VView from '@/components/VView.vue';
import VGame from '@/games/pixi-custom/VGame.vue';
import { SET_ATTACHMENT, SET_SCORE } from '@/store';
import VButton from '@/components/VButton.vue';

export default {
  name: 'ContestGame',
  components: {
    VText,
    VView,
    VGame,
    VButton,
  },
  methods: {
    onGameEnd({ attachment, score }) {
      this.$store.commit(SET_ATTACHMENT, { attachment });
      this.$store.commit(SET_SCORE, { score });

      this.$router.push('/contest/game3');
    },
  },
};
</script>

<style lang="scss" scoped>
.contest-game {
  padding-bottom: 0;

  ::v-deep .view__content {
    padding: 0;
  }
}
</style>
